import { useSWRConfig } from "swr";
import { RoutingLogic } from "src/queries/useRoutingLogic";
import { getUserToken } from "src/utils/jwtToken";
import { useActingAsOverrideHeader } from "../auth";
import { useTokenRefreshHandler } from "../hooks";
import { useUserService } from "../services";
import { errorHandler } from "src/hooks/errorHandler";

export function useUpdateRoutingLogicUser() {
  const accessToken = getUserToken();
  const { mutate, cache } = useSWRConfig();

  const service = useUserService();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  return (
    id: string | number,
    userId: string | number,
    body: Pick<RoutingLogic, "enabled" | "mapping_logic">,
  ) =>
    service
      .patch(`/api/meetings/definition/${id}/routing_logic/${userId}`)
      .set(headers)
      .send(body)
      .then(tokenRefreshHandler)
      .then((res: Response) => {
        // @ts-ignore
        const keys = cache.keys();

        // Invalidate contact queries and force refresh.
        Array.from(keys)
          .filter((r: any) =>
            r.includes(`/api/meetings/definition/${id}/routing_logic`),
          )
          .forEach((k: any) => {
            mutate(k);
          });

        return res;
      })
      .then((res: Response) => res.body)
      .catch(errorHandler);
}
